import styled from '@emotion/styled';
import { BrandListIntegrationStatusProps, IntegrationType } from 'types/integrations';
import LoggedInAsBrandBadge from 'ui/LoggedInAsBrandBadge';
import BrandOverviewHeaderItem from './BrandOverview.HeaderItem.Container';
import BrandListIntegrationStatus from 'components/BrandList/BrandListIntegrations/BrandListIntegrationStatus';
import { useFeatureFlag } from 'hooks';

const BrandOverviewHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 16px;
`;

type BrandOverviewHeaderProps = {
  integrations: BrandListIntegrationStatusProps['integrations'];
  brandId?: string;
  metaAdAccountId?: string;
  tiktokAdAccountId?: string;
};

const IntegrationsWrapper = styled.div`
  position: relative;
  gap: 4px;
  display: flex;
`;

const BrandOverviewHeader = ({
  integrations,
  metaAdAccountId,
  tiktokAdAccountId,
  brandId,
}: BrandOverviewHeaderProps) => {
  const { tiktokIntegration } = useFeatureFlag();

  const integrationsContent = (
    <IntegrationsWrapper>
      <BrandListIntegrationStatus
        includeIndicator
        brandId={brandId as string}
        integrations={integrations}
        type={IntegrationType.Facebook}
        isAdAccountActive={Boolean(metaAdAccountId)}
      />
      <BrandListIntegrationStatus
        includeIndicator
        brandId={brandId as string}
        integrations={integrations}
        type={IntegrationType.Shopify}
      />
      {tiktokIntegration && (
        <BrandListIntegrationStatus
          includeIndicator
          brandId={brandId as string}
          integrations={integrations}
          type={IntegrationType.TikTok}
          isAdAccountActive={Boolean(tiktokAdAccountId)}
        />
      )}
    </IntegrationsWrapper>
  );
  return (
    <BrandOverviewHeaderWrapper>
      <LoggedInAsBrandBadge />
      {metaAdAccountId && (
        <BrandOverviewHeaderItem
          canCopy
          label="Ad account ID"
          content={metaAdAccountId.replace('act_', '')}
        />
      )}
      {brandId && <BrandOverviewHeaderItem canCopy label="Proxima ID" content={brandId} />}
      <BrandOverviewHeaderItem top={8} label="Integrations" content={integrationsContent} />
    </BrandOverviewHeaderWrapper>
  );
};

export default BrandOverviewHeader;
